
import {
  UserGroupIcon,
  Squares2X2Icon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
  BookOpenIcon,
  CalculatorIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline";



export const statsData = [
  {
    id: 1,
    title: "6",
    value: " Learning Apps",
    icon: UserGroupIcon,
    arrowColor: "text-blue-600",
    link: "/progressbar"
  },
  {
    id: 2,
    title: "142",
    value: "Weekly Active Students",
    icon: Squares2X2Icon,
    arrowColor: "text-green-600",
  },
  {
    id: 3,
    title: "18m",
    value: "Avg. Session Length",
    icon: ClipboardDocumentListIcon,
    arrowColor: "text-orange-600",
  },

 {
    id: 4,
    title: "86%",
    value: "Compilation Rate",
    icon: ClipboardDocumentListIcon,
    arrowColor: "text-orange-600",
  },


];


export const performanceData = [
  { week: "Week 1", avg: 78 },
  { week: "Week 2", avg: 82 },
  { week: "Week 3", avg: 85 },
  { week: "Week 4", avg: 89 },
];

// export const milestones = [
//   { name: "Reading Level 3", value: 34.2, color: "bg-green-500" },
//   { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
//   { name: "Science Fundamentals", value: 34.2, color: "bg-yellow-500" },
//   { name: "MathMaster", value: 34.2, color: "bg-orange-500" },
//   { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
// ];



// // import { Squares2X2Icon, BeakerIcon, BookOpenIcon } from '@heroicons/react/24/outline';



// export const applicationTableHeaders = [
//   { key: "application", label: "APPLICATION" },
//   { key: "educator", label: "EDUCATOR" },
//   { key: "avgScore", label: "AVG SCORE" },
//   { key: "location", label: "LOCATION" },
//   { key: "usageHours", label: "USAGE HOURS" },
//   { key: "completion", label: "COMPLETION" },
// ];


// export const applications = [
//   {
//     name: 'Math Master',
//     icon: Squares2X2Icon,
//     educator: {
//       name: 'Michel Shen',
//       id: 'USR001',
//       avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=MS',
//     },
//     avgScore: 86,
//     location: 'California, USA',
//     usageHours: 120,
//     completion: 86,
//   },
//   {
//     name: 'Science Lab',
//     icon: BeakerIcon,
//     educator: {
//       name: 'Alice Johnson',
//       id: 'USR002',
//       avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=AJ',
//     },
//     avgScore: 92,
//     location: 'New York, USA',
//     usageHours: 80,
//     completion: 96,
//   },
//   {
//     name: 'History Hub',
//     icon: BookOpenIcon,
//     educator: {
//       name: 'John Doe',
//       id: 'USR003',
//       avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=JD',
//     },
//     avgScore: 78,
//     location: 'Texas, USA',
//     usageHours: 60,
//     completion: 70,
//   },
// ];

// export const ProgressBar = ({ percentage }) => {
//   const barColor = percentage > 90 ? 'bg-green-500' : 'bg-orange-500';
//   return (
//     <div className="w-full bg-gray-200 rounded-full h-2.5">
//       <div className={`${barColor} h-2.5 rounded-full`} style={{ width: `${percentage}%` }}></div>
//     </div>
//   );
// };



// export const myGoals = [
//   { title: "Reading Level", current: 2.2, target: 5.5, percentage: 85, color: "bg-green-500" },
//   { title: "Math Level", current: 3, target: 6, percentage: 50, color: "bg-blue-500" },
//   { title: "Writing Level", current: 1.5, target: 4, percentage: 40, color: "bg-yellow-500" },
// ];


 // ---------- Sample Data ----------
export const students = [
  {
    id: "USR001",
    name: "Michel Shen",
    avatar: "https://i.pravatar.cc/40?img=1",
    progress: 96,
    lastLogin: "2 hours ago",
    status: "Active",
  },
  {
    id: "USR002",
    name: "Sophia Lee",
    avatar: "https://i.pravatar.cc/40?img=2",
    progress: 86,
    lastLogin: "5 hours ago",
    status: "Active",
  },
  {
    id: "USR003",
    name: "David Kim",
    avatar: "https://i.pravatar.cc/40?img=3",
    progress: 46,
    lastLogin: "1 day ago",
    status: "Inactive",
  },
];




 export const educators = [
  {
    id: 1,
    name: "Sarah Johnson",
    status: "Active",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: 2,
    name: "Mike Chen",
    status: "Inactive",
    image: "https://randomuser.me/api/portraits/men/45.jpg",
  },
  {
    id: 3,
    name: "Emma Davis",
    status: "Active",
    image: "https://randomuser.me/api/portraits/women/46.jpg",
  },
  {
    id: 4,
    name: "Mike Chen",
    status: "Active",
    image: "https://randomuser.me/api/portraits/men/47.jpg",
  },
  {
    id: 5,
    name: "Emma Davis",
    status: "Inactive",
    image: "https://randomuser.me/api/portraits/women/47.jpg",
  },
];